<div
  class="entry-item"
  [ngClass]="{
    last: lastItem,
    'no-stock-error': noStockError && item?.updateable,
    'low-stock-error': lowStockError && item?.updateable,
    'unapproved-error': unapprovedError && item?.unavailableInB2B
  }"
>
  <!-- Item Image -->
  <hr class="one" *ngIf="pageId === cartPageId" />
  <hr class="two" *ngIf="pageId === cartPageId" />
  <hr class="three" [ngClass]="isShimanoMemoEnabled$ | async" *ngIf="pageId === cartPageId" />
  <div class="cart-image" [class.fish]="businessType === 'fish'">
    <a
      class="cx-link"
      [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
      (click)="viewItem()"
      *ngIf="pageId === cartPageId; else cartItemImage"
    >
      <ng-template [ngTemplateOutlet]="cartItemImage"></ng-template>
    </a>
    <ng-template #cartItemImage>
      <img
        [alt]="item.product.images?.PRIMARY.product.altText"
        [src]="getImageRendition(item.product.images?.PRIMARY)?.url"
        onerror="this.className='is-missing'"
      />
    </ng-template>
  </div>
  <!-- Item Info -->
  <div class="desc">
    <!-- code -->
    <div class="product-code" *ngIf="item.product.code">
      <span>
        {{ item.product.code }}
      </span>
    </div>
    <div class="stock-status">
      <ng-container
        *ngIf="pageId === cartPageId && !noStockError && item?.product?.stock?.stockLevelStatus === 'outOfStock'"
      >
        <span class="no-stock">
          {{ 'product.noStock' | cxTranslate }}
        </span>
      </ng-container>
      <ng-container
        *ngIf="
          pageId === cartPageId &&
          !noStockError &&
          item?.product?.stock?.stockLevelStatus !== 'outOfStock' &&
          item?.product?.stock?.stockLevelStatus !== 'discontinued' &&
          !item?.product?.manualAllocation
        "
      >
        <ng-container [ngSwitch]="(item?.product)['inStockFlag']">
          <span class="in-stock" *ngSwitchCase="true">
            {{ 'product.inStock' | cxTranslate }}
          </span>
          <span class="no-stock" *ngSwitchCase="false">
            {{ 'product.noStock' | cxTranslate }}
          </span>
        </ng-container>
      </ng-container>
      <ng-container
        *ngIf="
          item?.product?.manualAllocation &&
          item?.product?.stock?.stockLevelStatus !== 'discontinued' &&
          item?.product?.stock?.stockLevelStatus !== 'outOfStock'
        "
      >
        <span class="no-stock"> {{ 'product.noStock' | cxTranslate }}</span>
      </ng-container>
      <ng-container *ngIf="item?.product?.stock?.stockLevelStatus === 'discontinued'">
        <span class="discontinued">
          {{ 'product.discontinued' | cxTranslate }}
        </span>
      </ng-container>
      <ng-container *ngIf="pageId !== cartPageId && !item?.product?.manualAllocation">
        <ng-container [ngSwitch]="item?.backordered">
          <span class="no-stock" *ngSwitchCase="true">
            {{ 'product.noStock' | cxTranslate }}
          </span>
          <span class="in-stock" *ngSwitchCase="false">
            {{ 'product.inStock' | cxTranslate }}
          </span>
        </ng-container>
      </ng-container>
    </div>
    <!-- name -->
    <div class="product-name" *ngIf="item.product.name">
      <a
        class="cx-link"
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        (click)="viewItem()"
        *ngIf="pageId === cartPageId"
        [innerHTML]="item.product.name"
      >
      </a>
      <ng-container *ngIf="pageId !== cartPageId">
        <span [innerHTML]="item.product.name"> </span>
      </ng-container>
    </div>
    <!-- options -->
    <div class="global-variant" [class.product-variant-info]="pageId !== cartPageId" *ngIf="item?.variantInfo">
      <ng-container *ngFor="let variant of checkVariant(item?.variantInfo); let index = index; let last = last">
        <ng-container *ngIf="!last; else lastItem">{{ variant.parentCategoryName }}: {{ variant.name }}; </ng-container>
        <ng-template #lastItem>{{ variant.parentCategoryName }}: {{ variant.name }}</ng-template>
      </ng-container>
    </div>
    <!-- In ticket GB2B-26444, this is to display JAN code on the Japan site only -->
    <ng-container *ngIf="janCodeEnabled && pageId === cartPageId">
      <div class="jan-code">
        <div class="label">
          {{ 'cart.cartItem.jan' | cxTranslate }}
          <span class="attr-value" *ngIf="item.product?.jan || item.product?.ean">
            {{ item.product?.jan || item.product?.ean }}
          </span>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Item Price -->
  <div class="price" *ngIf="item.basePrice && pageId === cartPageId">
    <div class="label">
      {{ 'cart.cartItem.itemPrice' | cxTranslate }}
    </div>
    <ng-container>
      <div
        *ngIf="item.basePrice && !showSrp"
        class="value"
        [ngClass]="{
          'promo-version':
            (item.product.potentialPromotions && item.product.potentialPromotions.length > 0) ||
            (item.promotionMessage && item.promotionMessage !== '')
        }"
      >
        <ng-container *ngIf="!dealerSpinner; else elseDealerSpinner">
          <ng-container *ngIf="item.updateable && item.totalPrice.value > 0; else elseBlockBase">
            {{ item.basePrice?.formattedValue }}
            <span *ngIf="item.basePrice?.formattedValue && showGstExclusive$ | async" class="gst-label">{{
              'gst.exclusive' | cxTranslate
            }}</span>
            <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
          </ng-container>
          <ng-template #elseBlockBase>
            {{ item.totalPrice.formattedValue }}
            <span *ngIf="item.totalPrice.formattedValue && showGstExclusive$ | async" class="gst-label">{{
              'gst.exclusive' | cxTranslate
            }}</span>
            <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
          </ng-template>
        </ng-container>

        <ng-template #elseDealerSpinner>
          <div class="spinner-shimano-wrapper">
            <div class="spinner-shimano">
              <div></div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
  <!-- Item Quantity -->
  <div class="quantity">
    <cx-item-counter
      [control]="quantityControl"
      [readonly]="isReadOnlyInput(pageId, noStockError, item.updateable, item?.unavailableInB2B, unapprovedError)"
      [max]="999"
      [allowZero]="false"
      [itemCode]="item.product.code"
      (keypress)="numberOnly($event)"
      [moq]="minOrderQuantity"
      [isMinQty]="isMinQty"
    >
    </cx-item-counter>
  </div>
  <!-- Total -->
  <div *ngIf="item.totalPrice" class="total">
    <div class="label">{{ 'cart.cartItem.total' | cxTranslate }}</div>
    <ng-container>
      <div
        class="value"
        [class.discounted]="
          isDiscounted(item.totalPrice.value, item.basePrice?.value, item.quantity, appliedPromotions)
        "
        *ngIf="pageId === 'Checkout' || !showSrp"
      >
        {{ item.totalPrice.formattedValue }}
        <span *ngIf="item.totalPrice.formattedValue && showGstExclusive$ | async" class="gst-label">{{
          'cart.cartItem.gstExclusive' | cxTranslate
        }}</span>
      </div>
    </ng-container>
  </div>
  <!-- Action -->
  <div class="remove-btn" *ngIf="pageId === cartPageId">
    <button class="link" (click)="removeItem(item)" [disabled]="showSrp" *ngIf="item.updateable">
      <mat-icon
        matTooltip="{{ 'buttonTooltip.cart.deleteEntry' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="cart-delete-entry"
        aria-label="displays a tooltip in bottom"
        svgIcon="x-icon"
        [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
      ></mat-icon>
    </button>
  </div>

  <div class="memo">
    <ng-container *ngIf="shimanoMemoEnabled">
      <app-memo
        [memoControl]="memoControl"
        [readonly]="isMemoEnabled(noStockError)"
        [isMemoValid]="isMemoValid"
        [isInputValid]="isInputValid"
        [isLimitValid]="isLimitValid"
      ></app-memo>
    </ng-container>
  </div>

  <div class="lead-time delivery-timeline" *ngIf="pageId === cartPageId">
    <ng-container *ngIf="showWarehouseFeature; else showLeadTimeCartPage">
      <ng-container
        *ngIf="
          item.product?.stock.stockLevelStatus === 'backorder' &&
          item.product?.stock.stockLevel === 0 &&
          item.product?.monthLeadTime
        "
      >
        <div class="label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</div>
        <div class="value">{{ item.product?.monthLeadTime }}</div>
      </ng-container>
    </ng-container>

    <ng-template #showLeadTimeCartPage>
      <ng-container *ngIf="item.product?.leadTime">
        <div class="label" *ngIf="item.product?.stock.stockLevelStatus !== 'outOfStock'">
          {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
        </div>
        <div class="value" *ngIf="item.product?.stock.stockLevelStatus === 'inStock'">
          {{ 'cart.cartItem.leadtime.value.instock' | cxTranslate : { time: item.product?.leadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
        <div class="value" *ngIf="item.product?.stock.stockLevelStatus === 'backorder'">
          {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item.product?.leadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
      </ng-container>
    </ng-template>
  </div>

  <div class="lead-time delivery-timeline" *ngIf="pageId !== cartPageId">
    <ng-container *ngIf="showWarehouseFeature; else showLeadTimeCheckout">
      <div *ngIf="item?.backordered && item?.inventoryLeadTime">
        <span class="label lead-time-label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</span>
        <span class="value lead-time-value">{{ item?.inventoryLeadTime }}</span>
      </div>
    </ng-container>

    <ng-template #showLeadTimeCheckout>
      <div
        *ngIf="!item.backordered && item?.deliveryDate; else noDeliveryDate"
        class="value"
        [innerHTML]="
          'cart.cartItem.delivery.value.instock' | cxTranslate : { time: item?.deliveryDate | date : dateFormatted }
        "
      ></div>
      <ng-template #noDeliveryDate>
        <div *ngIf="!item.backordered && checkLeadTime(item?.inventoryLeadTime)" class="value lead-time-label">
          <span class="label lead-time-label">
            {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
          </span>
          {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item?.inventoryLeadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
        <div *ngIf="item.backordered && checkLeadTime(item?.inventoryLeadTime)" class="value lead-time-label">
          <span class="label lead-time-label">
            {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
          </span>
          {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item?.inventoryLeadTime } }}
          {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
        </div>
      </ng-template>
    </ng-template>
  </div>

  <div
    class="promotional-text"
    [ngClass]="shimanoMemoEnabled ? '' : 'noMemo'"
    *ngIf="pageId === cartPageId && !showSrp"
  >
    <app-promotional-text
      [product]="item.product"
      [appliedProductPromotions]="appliedPromotions"
      [promotionLocation]="promotionLocation"
      [cartItem]="item"
      [orderEntryNumber]="item.entryNumber"
      [hasMemoField]="shimanoMemoEnabled ? 'true' : 'false'"
    ></app-promotional-text>
  </div>
</div>
